var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.95,
    height: 17.95,
    viewBox: "0 0 17.95 17.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".menua{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-56.794 -22.594)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "menua",
    d: "M13.865,3.161c-1.094,0-2.029.031-2.827.021-.8.01-1.739-.018-2.835-.021-2.64-.013-5.176.009-7.922.147L0,.023C3.047.049,5.745.111,8.677.107L8.962.093A12.1,12.1,0,0,1,11.038.006a12.105,12.105,0,0,1,2.076.086L13.4.107c2.929,0,5.63-.058,8.678-.084l-.282,3.286C19.047,3.17,16.517,3.148,13.865,3.161Z",
    transform: "translate(56.794 38.204) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "menua",
    d: "M13.865.147c-1.094,0-2.029-.031-2.827-.021C10.235.116,9.3.144,8.2.147,5.562.16,3.026.138.28,0L0,3.286C3.047,3.259,5.745,3.2,8.677,3.2l.285.014a12.1,12.1,0,0,0,2.076.086,12.105,12.105,0,0,0,2.076-.086L13.4,3.2c2.929,0,5.63.058,8.678.084L21.794,0C19.047.138,16.517.16,13.865.147Z",
    transform: "translate(72.404 40.543) rotate(-135)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.1d06ebc58606e43a89ae4ed05d1af558.svg";
export { ForwardRef as ReactComponent };